// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'

export class AddPathElements {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): AddPathElements {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsAddPathElements(bb: flatbuffers.ByteBuffer, obj?: AddPathElements): AddPathElements {
    return (obj || new AddPathElements()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsAddPathElements(bb: flatbuffers.ByteBuffer, obj?: AddPathElements): AddPathElements {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new AddPathElements()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  ink(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  encodedCenterPathElements(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0
  }

  encodedCenterPathElementsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  encodedCenterPathElementsArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset)
        )
      : null
  }

  encodedCenterPathEstimatedElements(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0
  }

  encodedCenterPathEstimatedElementsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  encodedCenterPathEstimatedElementsArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset)
        )
      : null
  }

  static startAddPathElements(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addInk(builder: flatbuffers.Builder, inkOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, inkOffset, 0)
  }

  static addEncodedCenterPathElements(
    builder: flatbuffers.Builder,
    encodedCenterPathElementsOffset: flatbuffers.Offset
  ) {
    builder.addFieldOffset(1, encodedCenterPathElementsOffset, 0)
  }

  static createEncodedCenterPathElementsVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!)
    }
    return builder.endVector()
  }

  static startEncodedCenterPathElementsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1)
  }

  static addEncodedCenterPathEstimatedElements(
    builder: flatbuffers.Builder,
    encodedCenterPathEstimatedElementsOffset: flatbuffers.Offset
  ) {
    builder.addFieldOffset(2, encodedCenterPathEstimatedElementsOffset, 0)
  }

  static createEncodedCenterPathEstimatedElementsVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!)
    }
    return builder.endVector()
  }

  static startEncodedCenterPathEstimatedElementsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1)
  }

  static endAddPathElements(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // ink
    return offset
  }

  static createAddPathElements(
    builder: flatbuffers.Builder,
    inkOffset: flatbuffers.Offset,
    encodedCenterPathElementsOffset: flatbuffers.Offset,
    encodedCenterPathEstimatedElementsOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    AddPathElements.startAddPathElements(builder)
    AddPathElements.addInk(builder, inkOffset)
    AddPathElements.addEncodedCenterPathElements(builder, encodedCenterPathElementsOffset)
    AddPathElements.addEncodedCenterPathEstimatedElements(builder, encodedCenterPathEstimatedElementsOffset)
    return AddPathElements.endAddPathElements(builder)
  }
}
